import { getFeatureSetting } from "common/feature-settings";
import { FrontendEventFields } from "common/tracing";

import { getLocationSettings } from "./location";

// Not a secret
const apiKey = "529495202dce95b3d7cc813672bb34ad";

// https://docs.honeycomb.io/getting-data-in/javascript/browser-js/#can-i-send-data-directly-to-honeycomb-from-the-browser
export function honeycombSendEvent(event: FrontendEventFields): void {
    const datasetName = getLocationSettings().honeycombDatasetName;
    const xhr = new XMLHttpRequest();
    const apiHostname = getFeatureSetting("honeycombToAxiom") ? "glidehcproxy.axiomtestlabs.co" : "api.honeycomb.io";
    xhr.open("POST", `https://${apiHostname}/1/events/${encodeURIComponent(datasetName)}`, true);
    xhr.setRequestHeader("X-Honeycomb-Team", apiKey);
    xhr.send(JSON.stringify(event));
}
